<template>
  <div class="onboarding-distribute-early-view">
    <div class="onboarding-distribute-early-view--text-wrapper">
      <h1 class="onboarding-distribute-early-view--text">
        Occasionally, we are able to get your first mow scheduled a day earlier. If a crew is
        available, would you want it done then?
      </h1>
      <div class="onboarding-distribute-early-view--buttons">
        <LsButton
          class="onboarding-distribute-early-view--button"
          text="yes"
          test-id="yes"
          track-id="onboarding_distribute_early_view-yes"
          :disabled="onboarding.loadingStatus.isUpdating"
          :loading="isUpdatingYes"
          @click="syncOrder({ distribute_early: true })"
        />
        <LsButton
          class="onboarding-distribute-early-view--button"
          text="no"
          test-id="no"
          track-id="onboarding_distribute_early_view-no"
          bg-color="primary-light"
          text-color="primary"
          :disabled="onboarding.loadingStatus.isUpdating"
          :loading="isUpdatingNo"
          @click="syncOrder({ distribute_early: false })"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LsButton from '@/components/common/LsButton/LsButton.vue';
import { mapActions, mapState } from 'vuex';
import { ONBOARDING__SYNC_ORDER } from '@/store/types';

export default {
  name: 'OnboardingDistributeEarlyView',
  components: { LsButton },
  data() {
    return {
      isUpdatingYes: false,
      isUpdatingNo: false,
    };
  },
  computed: {
    ...mapState(['onboarding']),
  },
  methods: {
    ...mapActions([ONBOARDING__SYNC_ORDER]),
    async syncOrder({ distribute_early }) {
      if (distribute_early) {
        this.isUpdatingYes = true;
      } else {
        this.isUpdatingNo = true;
      }
      await this[ONBOARDING__SYNC_ORDER]({ distribute_early });

      this.isUpdatingYes = false;
      this.isUpdatingNo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-distribute-early-view {
  display: flex;
  justify-content: center;
  align-items: center;
}

.onboarding-distribute-early-view--text-wrapper {
  margin-top: 50px;
  min-height: 400px;
  max-width: 670px;
  border: 1px solid $primary-light;
  display: flex;
  justify-content: space-around;
  align-self: center;
  align-items: center;
  flex-direction: column;
  padding: 60px;
}

.onboarding-distribute-early-view--text {
  font-size: $size-2;
}

.onboarding-distribute-early-view--buttons {
  display: flex;
  flex-direction: column;
}

.onboarding-distribute-early-view--button {
  margin-top: 12px;
}
.themed-app {
  .onboarding-distribute-early-view--text-wrapper {
    border-color: $theme-color-primary-light;
  }
  .onboarding-distribute-early-view--text {
    font-size: $theme-txt-title;
  }
}
</style>
